import { Platform } from '@cart-services/hooks/fp-b2b/store-map'
import { useFpB2bCartCalculate } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-calculate'
import { OrderDetail } from '@cart-ui/OrderDetail/OrderDetail'
import { projectNameMap } from '@constants'
import { useDialog } from '@dni-hooks/useDialog'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { Box } from '@pets-ui/Box/Box'
import { Chip } from '@pets-ui/Chip/Chip'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { ResponsiveDialog } from '@pets-ui/ResponsiveDialog/ResponsiveDialog'
import { useState } from 'react'
import { useStmBrandStore } from '../../hooks'

export const DIALOG_ORDER_DETAIL = 'DIALOG_ORDER_DETAIL'

export interface DialogOrderDetailProps {
  initialCampaignCode: string
}

interface DialogOrderDetailContentProps {
  initialCampaignCode: string
  onClose: () => void
}

const DialogOrderDetailContent = (props: DialogOrderDetailContentProps) => {
  const { initialCampaignCode, onClose } = props
  const { brands } = useStmBrandStore()

  const [selectedCampaignCode, setSelectedCampaignCode] = useState<string | null>(null)
  const activeCampaignCode = selectedCampaignCode ?? initialCampaignCode
  const activeBrand = brands.find(b => b.campaignCode === activeCampaignCode) ?? null

  const { calculateResult } = useFpB2bCartCalculate(activeBrand?.campaignId ?? null, activeBrand?.campaignCode ?? '', Platform.STM)
  const { destructuredData: campaign } = useApiCampaignActivityInfo(activeBrand?.campaignCode ?? '')
  const currency = campaign?.currency

  return (
    <>
      <DialogHeader title="明細" onClose={onClose} />
      <Box p={3} display="flex" flexDirection="column" gap={3}>
        <Box display="flex" flexWrap="wrap" gap={3}>
          {brands.map(brand => (
            <Chip
              key={brand.campaignCode}
              color={activeBrand?.campaignCode === brand.campaignCode ? 'red' : 'default'}
              selected={activeBrand?.campaignCode === brand.campaignCode}
              isOutlined
              onClick={() => setSelectedCampaignCode(brand.campaignCode)}
            >
              {projectNameMap[brand.projectCode] ?? brand.projectCode}
            </Chip>
          ))}
        </Box>
        {activeBrand && (
          <OrderDetail
            discountItems={calculateResult?.discount_items || []}
            shippingTotal={calculateResult?.shipping_total ?? 0}
            total={calculateResult?.total ?? 0}
            subtotal={calculateResult?.subtotal ?? 0}
            subtotalAfterDiscount={calculateResult?.total_without_addon_v2 ?? 0}
            tax={calculateResult?.tax ?? 0}
            currency={currency || 'TWD'}
            countryCode={activeBrand.countryCode}
            addonV2Total={calculateResult?.addon_v2_total ?? 0}
            addonV2TotalBeforeDiscount={calculateResult?.addon_v2_total_before_discount ?? 0}
          />
        )}
      </Box>
    </>
  )
}

export const DialogOrderDetail = () => {
  const { open, closeDialog, initialCampaignCode } = useDialog<DialogOrderDetailProps>(DIALOG_ORDER_DETAIL)

  return (
    <ResponsiveDialog
      open={open}
      onClose={closeDialog}
      fullWidth
    >
      {open && <DialogOrderDetailContent initialCampaignCode={initialCampaignCode} onClose={closeDialog} />}
    </ResponsiveDialog>
  )
}
